module.exports = __webpack_public_path__ + "static/img/MS02.6cef771.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/MS02.jpg
// module id = y7Jb
// module chunks = 9